import {
  ApplicationConfig,
  LOCALE_ID,
  provideZoneChangeDetection,
  importProvidersFrom,
} from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import CustomTheme from '../style/vendor/primeng/themes/custom-theme/custom-theme';
import { httpInterceptors } from './core/config/http-interceptors';
import { ConfirmationService, MessageService } from 'primeng/api';
import { FormlyConfigModule } from './core/plugin/formly/formly.module';
import { CognitoAuthService } from './shared/service/cognito-auth.service';
import { appRoutes } from './app.routes';
import { AUTH_PROVIDER } from './shared/common/injector-token';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateConfig } from './core/config/translate.config';
import { provideStore } from '@ngxs/store';
import {
  ngxsConfig,
  ngxsStates,
  ngxsStorageConfig,
} from './core/config/ngxs.config';
import { withNgxsStoragePlugin } from '@ngxs/storage-plugin';
import { withNgxsRouterPlugin } from '@ngxs/router-plugin';

const globalServices = [
  { provide: AUTH_PROVIDER, useExisting: CognitoAuthService },
  MessageService,
  ConfirmationService,
];

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
      })
    ),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimationsAsync(),
    TranslateModule.forRoot(TranslateConfig).providers!,
    providePrimeNG({
      ripple: false,
      theme: {
        preset: CustomTheme,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-mode',
          cssLayer: {
            name: 'primeng',
            order:
              'normalize, app-styles, primeng, primeicons, primeflex, custom',
          },
        },
      },
    }),
    provideStore(
      ngxsStates,
      ngxsConfig,
      withNgxsStoragePlugin(ngxsStorageConfig),
      withNgxsRouterPlugin()
    ),
    importProvidersFrom(FormlyConfigModule.forRoot()),
    { provide: LOCALE_ID, useValue: 'en-US' },
    ...httpInterceptors,
    ...globalServices,
  ],
};
